import Collapse from '@mui/material/Collapse';
import type { TranslationTag } from '@ps/web-core-intl';
import { InfoIcon, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useState } from 'react';

import ArrowIcon from '@swf/core/assets/icons/arrow.svg';
import LockIcon from '@swf/core/assets/icons/lock.svg';

import CTAButton from '../../../../../CTAButton/CTAButton';
import Container from '../../../../../Container/Container';

import {
  TXTCLI_We_encrypt_your_data_so_itXs_s_ELL_1,
  TXTWCL_How_is_my_data_kept_safeX
} from './RMFSSNContainer.messages.json';
import { active, arrow, arrowContainer, infoBox, infoText, subtitle } from './RMFSSNContainer.scss';

export interface SSNContainerProps {
  title: TranslationTag;
  pageTopTitle: TranslationTag;
  pageTopSubtitle: React.ReactNode;
  showLockIcon?: boolean;
  page: React.ComponentType;
}

const RMFSSNContainer: React.FC<React.PropsWithChildren<SSNContainerProps>> = ({
  title,
  pageTopSubtitle,
  pageTopTitle,
  children,
  page,
  showLockIcon
}) => {
  const [infoExpanded, setInfoExpanded] = useState<boolean>(false);

  return (
    <Container
      page={page}
      headerProps={{
        title: <Translation {...title} />
      }}
      pageTopTitle={<Translation {...pageTopTitle} />}
      pageTopSubtitle={
        <div className={subtitle}>
          {showLockIcon && <LockIcon />}
          <div>{pageTopSubtitle}</div>
        </div>
      }
    >
      {children}
      <div className={infoBox} onClick={() => setInfoExpanded(!infoExpanded)}>
        <InfoIcon />
        <div className={infoText}>
          <Translation {...TXTWCL_How_is_my_data_kept_safeX} />
        </div>
        <div className={arrowContainer}>
          <ArrowIcon className={classNames(arrow, { [active]: infoExpanded })} />
        </div>
      </div>
      <Collapse in={infoExpanded}>
        <Translation {...TXTCLI_We_encrypt_your_data_so_itXs_s_ELL_1} />
      </Collapse>
      <CTAButton />
    </Container>
  );
};

export default RMFSSNContainer;
